import React from "react";
import PropTypes from "prop-types";
import { lighten, darken } from "polished";
//Styles
import styled from "styled-components";
import Icon from "../../atoms/Icon";
import theme from './../../../styles/theme.semantic'

const CustomArrow = ({
  className,
  onClick,
  left,
  darken,
  ariaLabel,
  tabIndex,
  color,
  ...props
}) => {
  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
    >
      <Icon
        name={`${left ? "fal fa-chevron-left" : "fal fa-chevron-right"}`}
        darken={darken}
        color={color}
        {...props}
        fontSize="36px"
      />
    </button>
  );
};

CustomArrow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  name: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.shape({}),
  darken: PropTypes.bool,
  left: PropTypes.bool,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ariaLabel: PropTypes.string,
  color: PropTypes.string,
};

CustomArrow.defaultProps = {
  left: false,
  darken: false,
  tabIndex: "-1",
  color: theme.components.customArrow.customArrowColor,
};

export default styled(CustomArrow)`
  z-index: ${props => props.zIndex || "2"};
  &:focus {
    ${props => props.theme.mixins.focus()};
  }
  &.slick-disabled {
    opacity: 0.4;
    outline: none;
    i {
      cursor: default;
      &:hover {
        ${props =>
          props.darken
            ? `color: ${darken(0, theme.components.customArrow.customArrowColor)}`
            : `color: ${lighten(0, theme.components.customArrow.customArrowColor)}`};
      }
    }
  }
`;
